import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-black border-t border-white/10 pt-20 pb-10" data-id="element-370">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-371">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-372">
          {/* Company Info */}
          <div className="flex flex-col gap-6" data-id="element-373">
            <Link to="/" className="flex items-center gap-2" data-id="element-374">
              <img src="https://cdn.magicpatterns.com/uploads/tEKY1KVFn8NPQae4HonbJW/9fea8157-abe6-4116-8e53-72149f139631.png" alt="Design Flow Digitals" className="w-10 h-10 object-contain" data-id="element-375" />
              <span className="font-bold text-xl tracking-tight text-white" data-id="element-376">
                Design Flow Digitals
              </span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-377">
              Premium Shopify development company specializing in themes, apps
              and high-converting ecommerce stores.
            </p>
            <div className="text-sm text-gray-500" data-id="element-378">
              <p data-id="element-379">Part of Pankaj Maurya LLC</p>
              <p data-id="element-380">67 Wigley Loop</p>
              <p data-id="element-381">Whitwell, TN 37397</p>
              <p data-id="element-382">United States</p>
            </div>
            <a href="mailto:support@designflowdigitals.com" className="text-gradient-gold font-medium text-sm hover:opacity-80 transition-opacity" data-id="element-383">
              support@designflowdigitals.com
            </a>
          </div>

          {/* Company Links */}
          <div data-id="element-384">
            <h3 className="text-white font-semibold mb-6" data-id="element-385">Company</h3>
            <ul className="flex flex-col gap-4" data-id="element-386">
              <li data-id="element-387">
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-388">
                  About Us
                </Link>
              </li>
              <li data-id="element-389">
                <Link to="/team" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-390">
                  Meet the Team
                </Link>
              </li>
              <li data-id="element-391">
                <Link to="/portfolio" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-392">
                  Portfolio
                </Link>
              </li>
              <li data-id="element-393">
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-394">
                  Contact
                </Link>
              </li>
              <li data-id="element-395">
                <Link to="/support" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-396">
                  Support Center
                </Link>
              </li>
            </ul>
          </div>

          {/* Shopify Apps */}
          <div data-id="element-397">
            <h3 className="text-white font-semibold mb-6" data-id="element-398">Shopify Apps</h3>
            <ul className="flex flex-col gap-4" data-id="element-399">
              <li data-id="element-400">
                <Link to="/apps" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-401">
                  All Apps
                </Link>
              </li>
              <li data-id="element-402">
                <Link to="/seo-suite" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-403">
                  SEO Suite App
                </Link>
              </li>
              <li data-id="element-404">
                <Link to="/ai-photoshoot" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-405">
                  AI Photoshoot App
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-406">
            <h3 className="text-white font-semibold mb-6" data-id="element-407">Services</h3>
            <ul className="flex flex-col gap-4" data-id="element-408">
              <li data-id="element-409">
                <Link to="/services/store-development" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-410">
                  Store Development
                </Link>
              </li>
              <li data-id="element-411">
                <Link to="/services/theme-development" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-412">
                  Theme Development
                </Link>
              </li>
              <li data-id="element-413">
                <Link to="/services/app-development" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-414">
                  App Development
                </Link>
              </li>
              <li data-id="element-415">
                <Link to="/services/conversion-optimization" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-416">
                  Conversion Optimization
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-417">
          <p className="text-gray-500 text-sm" data-id="element-418">
            &copy; {currentYear} Design Flow Digitals. All rights reserved.
          </p>
          <div className="flex items-center gap-6" data-id="element-419">
            <Link to="/privacy-policy" className="text-gray-500 hover:text-white transition-colors text-sm" data-id="element-420">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-500 hover:text-white transition-colors text-sm" data-id="element-421">
              Terms of Service
            </Link>
            <Link to="/refund-policy" className="text-gray-500 hover:text-white transition-colors text-sm" data-id="element-422">
              Refund Policy
            </Link>
            <Link to="/cookies-policy" className="text-gray-500 hover:text-white transition-colors text-sm" data-id="element-423">
              Cookies Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}